<div class="ss-toast" *ngIf="toastMessage" [class.ss-toast-error]="toastType === 'error'">{{ toastMessage }}</div>

<div class="scan-page">
  <div class="scan-header">
    <h1 class="ss-page-title">SafeScan Batch</h1>
    <button *ngIf="isBatchPick" class="ss-btn ss-btn-primary ss-btn-sm" (click)="openBatchPick()">← Back to BatchPick</button>
    <button class="ss-btn ss-btn-success ss-btn-sm" (click)="triggerPrintPickList()">Print Pick List</button>
  </div>

  <div class="scan-input-area">
    <input #barcodeInput type="text" (keyup.enter)="handleBarcode(barcodeInput)" id="barcodeinput"
      class="ss-input" style="width:260px" placeholder="Scan barcode…" autofocus *ngIf="!finishedScan && !viewOnly" />
    <span *ngIf="isScannerActive && !finishedScan && !viewOnly" class="scan-active-label">Scanning</span>
    <span *ngIf="viewOnly && !batchPickInProgress" class="scan-active-label">Finished batch: reprint bag labels only</span>
    <span *ngIf="batchPickInProgress" class="scan-active-label">Batch Pick batch: scan it on the pick and verify screens</span>
  </div>

  <!-- Scan medication component -->
  <app-scanmedication [isStartBtnClicked]="isStartBtnClicked"
    (isScanFinished)="isScanFinished($event)"
    (modalClosed)="refocusBarcode()"></app-scanmedication>

  <!-- Print pick list (hidden) -->
  <div id="printlist" style="display:none">
    <div class="print-container">
      <div class="print-top-bar">
        <div class="print-date">{{ todayDate }}</div>
        <div class="print-logos">
          <img src="../../assets/images/mclernons.png" class="print-logo" />
          <img src="../../assets/images/safescan.png" class="print-logo" />
        </div>
      </div>
      <hr />
      <h2 class="print-title">Batch Pick List</h2>
      <table>
        <thead>
          <tr>
            <th class="col-stock">Stock Item</th>
            <th class="col-prescription">Prescription ID</th>
            <th class="col-qty">Quantity</th>
            <th class="col-picked">Picked Y/N</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let medication of objectKeys(groupedMedications)">
            <td>{{ medication }}</td>
            <td>Ending -{{ getLastChars(groupedMedications[medication].prescriptionIds?.[0]) }}</td>
            <td>{{ groupedMedications[medication].quantity }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Print medicines (hidden) -->
  <div id="print-medicines" style="display:none">
    <div class="med-container" *ngFor="let medicine of printMedications">
      <div class="medicine">
        <div class="text-section">
          <p class="child-warning">Keep out of sight & reach of children</p>
          <h4 class="med-name">{{ medicine.medicationName }} {{ medicine.medicineDosage }}</h4>
          <p class="dose-instruction">{{ medicine.instruction }}</p>
        </div>
        <div class="barcode-section">
          <ngx-barcode6 [bc-value]="medicine.medicationId" [bc-display-value]="false" [bc-width]="1" [bc-height]="20">
          </ngx-barcode6>
        </div>
      </div>
    </div>
  </div>
</div>
